// frontend/src/utils/notify.ts
export const notify = {
  success: (message: string) => {
    // Просто показываем сообщение через alert (можно заменить на более красивое решение)
    alert(`✅ ${message}`);
  },
  error: (message: string) => {
    alert(`❌ ${message}`);
  },
  info: (message: string) => {
    alert(`ℹ️ ${message}`);
  },
  confirm: (message: string): boolean => {
    return window.confirm(message);
  },
};